export function V2Spinner({ size = 14, className = "" }) {
  return (
    <span
      className={`v2-spinner ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    />
  );
}

export function V2Skeleton({ className = "", style }) {
  return <span className={`v2-skeleton ${className}`} style={style} aria-hidden="true" />;
}

export function V2RefreshChip({ label }) {
  return (
    <span className="v2-refresh-chip">
      <V2Spinner />
      {label}
    </span>
  );
}

export default function V2BusyFrame({
  loading = false,
  label,
  className = "",
  children,
}) {
  return (
    <div
      className={`v2-busy-frame ${className}`}
      aria-busy={loading || undefined}
      aria-label={loading ? label : undefined}
    >
      {children}
      {loading ? <div className="v2-refresh-overlay" aria-hidden="true" /> : null}
    </div>
  );
}
